import { createRootRoute, Outlet } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

export const Route = createRootRoute({
  component: () => {
    const [qc] = useState(
      () =>
        new QueryClient({
          defaultOptions: {
            queries: { staleTime: Infinity, retry: 1, refetchOnWindowFocus: false },
          },
        }),
    );
    return (
      <QueryClientProvider client={qc}>
        <Outlet />
      </QueryClientProvider>
    );
  },
});
